import type { ClubSelection } from "./club-selection";

/** Sent on every API response when the page is on a club's own domain (src/clubcore/ops/hosting.py). */
export const HOST_CLUB_HEADER = "X-ClubCore-Host-Club";
export const HOST_PURPOSE_HEADER = "X-ClubCore-Host-Purpose";

/**
 * Follow what the server says about this host: on a club's own domain the staff app works in that club only, and a domain that
 * serves only the member portal sends the browser there.
 */
export function followHostClub(headers: Headers, selection: ClubSelection, go: (path: string) => void = (path) => window.location.replace(path)): void {
  const slug = headers.get(HOST_CLUB_HEADER);
  if (!slug) return;
  if (headers.get(HOST_PURPOSE_HEADER) === "portal") {
    go("/member/");
    return;
  }
  selection.pin(slug);
}
